var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LandingGif } from '@assets';
import { APP_ROUTES, Button, useAppSelector } from '@core';
import { AUTH_ROUTES } from '@features/auth/constants';
import { DESIGNING_ROUTES } from '@features/home/constants';
import { useNavigate } from 'react-router-dom';
export var PageTop = function () {
    var navigate = useNavigate();
    var isAuthenticated = useAppSelector(function (store) { var _a; return (_a = store.authData.data) === null || _a === void 0 ? void 0 : _a.isAuth; });
    console.log('isAuthenticated:', isAuthenticated);
    var handleStart = function () {
        if (isAuthenticated) {
            navigate(APP_ROUTES.designing.route + '/' + DESIGNING_ROUTES.main.route);
        }
        else {
            navigate(APP_ROUTES.auth.route + '/' + AUTH_ROUTES.login.route);
        }
    };
    return (_jsxs("div", __assign({ className: "flex w-full flex-col items-center bg-white" }, { children: [_jsx("div", __assign({ className: "mb-[15px] flex w-[35.73%]" }, { children: _jsx("span", __assign({ className: "text-center font-montserrat text-[35px] font-bold leading-[43px]" }, { children: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u044B\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0432 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435" })) })), _jsx("div", __assign({ className: "mb-[40px] flex w-[35.73%]" }, { children: _jsx("span", __assign({ className: "text-center font-montserrat text-[20px] leading-[24px]" }, { children: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u043E\u0434\u0431\u043E\u0440\u0430 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439 \u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0440\u0443\u0442\u0438\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432" })) })), _jsx(Button, __assign({ className: "mb-[44px] text-[22px] leading-[27px]", onClick: handleStart }, { children: isAuthenticated ? 'начать проектирование' : 'начать расчет' })), _jsx("img", { src: LandingGif, alt: "GIF", className: "flex w-full" })] })));
};
